import { WidgetFeature } from 'enums/WidgetFeature';

export const defaultChatTitle = 'ВТБ';
export const defaultButtonTitle = 'Чат с банком';

export const defaultTechAgentName = 'Бот';

export const defaultFakeAgentName = 'Бот-помощник';

export const unauthorizedFeaturesOverride: Partial<Record<WidgetFeature, boolean>> = {
    [WidgetFeature.Favorites]: false,
    [WidgetFeature.HistoryDumpTxt]: false,
    [WidgetFeature.HistoryDumpHtml]: false,
    [WidgetFeature.WaitingGameHiScore]: false,
};

export const defaultWidgetWidth = 470;

export const defaultWidgetHeight = 760;

export const defaultWidgetWidthMaximized = 700;

export const mobileBreakPoint = 768;

export const widgetStateToggleUrlParam = 'chat';

export const defaultWidgetMargin = {
    top: 40,
    right: 12,
    bottom: 40,
    left: 12,
};

export const defaultZIndex = 100_001; // TODO: Change to 100 when all consumers are ready

export const masterSoundVolume = 0.5;

export const chatHashString = '#chat';

export const imageAggregatePageSize = 30;

export const maxSafeCurency = 10_000_000_000_000;

export const pingInterval = 10; // Seconds

export const checkJwtInterval = 1; // Seconds

export const predictivesDebounce = 500; // Ms

export const predictivesMinChars = 3;

export const voiceRecordTimeslice = 2_000; // Ms

export const voiceRecordLimit = 20_000; // Ms

// How many pixels away from the screen border the context menu should pop-up
export const contextMenuEdgeOffset = 16;

export const ctxMenuMinWidth = 250;
export const ctxMenuMaxWidth = 292;

export const ctxMenuMinHeight = 164;
export const ctxMenuMaxHeight = window.innerHeight;
export const ctxFilesMenuMinHeight = 112;
export const ctxLinksMenuMinHeight = 56;
